import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getPaymentList } from '@/utils/paymentList';

export const procedurePaymentListRoute: RouteConfig = {
  path: 'payment-list',
  name: 'procedurePaymentList',
  component: () =>
    import(/* webpackChunkName: "ProcedurePaymentList" */ '@/views/mainRoute/procedure/payments/PaymentList.vue'),
  meta: { breadcrumb: { title: 'Lista wypłat' } },
  beforeEnter(to, from, next) {
    getPaymentList(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.PAYMENT_LIST_CANNOT_GET }));
  }
};
